import { DivConst } from 'constants/divConst';
import { getDivLabel } from 'utils/app';

import type { JSX } from 'react';

/**
 * ボイスチャットステータス表示コンポーネント
 */
export default function VoiceChatStatusBadge(props: {
  voiceChatStatusDiv: number | null;
  size?: 'normal' | 'large';
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const getClassColor = (): string => {
    // 稼働
    if (DivConst.items.voiceChatStatus.published.value === props.voiceChatStatusDiv) {
      return 'form-status-published';
    }
    // 稼働（予約）
    else if (DivConst.items.voiceChatStatus.reserved.value === props.voiceChatStatusDiv) {
      return 'form-status-reserved';
    }
    // 未稼働
    return 'form-status-unpublished';
  };

  const getClassSize = (): string => {
    if (props.size === 'large') {
      return 'badge-common-lg ';
    }
    return '';
  };

  const getName = (): string => {
    if (props.voiceChatStatusDiv == null) {
      return '';
    }
    return getDivLabel('voiceChatStatus', props.voiceChatStatusDiv);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <span className={`badge badge-common ${getClassSize()} ${getClassColor()}`}>{getName()}</span>
    </>
  );
}
